import { ComponentChildren, createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { AnyExtendedWidgetSettings, AnyWidgetSettings } from 'types/settings';
import { useGeoLocation } from 'utilities/use-geolocation';

export const SettingsContext = createContext<AnyExtendedWidgetSettings | null>(
  null,
);

interface SettingsProvider {
  children: ComponentChildren;
  widgetSettings: AnyWidgetSettings;
}

export function useSettings<T extends AnyExtendedWidgetSettings>() {
  const context = useContext(SettingsContext);

  if (context === null) {
    throw new Error('Webtex Reviews: No settings context provided');
  }

  return context as T;
}

export function SettingsProvider({
  children,
  widgetSettings,
}: SettingsProvider) {
  const { geolocation, isLoading } = useGeoLocation();

  if (isLoading) {
    return null;
  }

  const { settings, ...utils } = window.wbtxReviewsUtils;

  const contextValue: AnyExtendedWidgetSettings = {
    ...widgetSettings,
    settings,
    utils: { ...utils, geolocation },
  };

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
}
